import { Component, input } from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { ActionButtonDisabilityPipe } from '../../pipes/action-button-disability.pipe';
import { TrueOrFalsePipe } from '../../../boolean/pipes/true-or-false.pipe';
import { PrimengButtonDirective } from '../../../button/directives/primeng-button.directive';
import { ActionButtonVariantCssPipe } from '../../pipes/action-button-variant-css.pipe';
import { ActionButton } from '../../models/action-button';
import { ActionButtonType } from '../../enums/action-button-type';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-action-button',
  imports: [
    ButtonModule,
    ActionButtonDisabilityPipe,
    TrueOrFalsePipe,
    PrimengButtonDirective,
    MenuModule,
    ActionButtonVariantCssPipe,
    RouterLink,
  ],
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent<Action> {
  public readonly action = input.required<ActionButton<Action>>();

  protected readonly ActionButtonType = ActionButtonType;
}
